/* eslint-disable no-use-before-define, eqeqeq */
import React from 'react'
import { Status, ajax, evalJson, } from '../twd/twd'

export const Context = React.createContext()

export const ContextProvider = ({
    children
} = {}) => {
    const [status, setStatus] = React.useState(Status.LOADING)
    const [auctions, setAuctions] = React.useState([])
    const [upcoming, setUpcoming] = React.useState([])
    const [schedules, setSchedules] = React.useState([])


    React.useEffect(() => {(async () => {
        try {
            setStatus(Status.LOADING)

            const { data:auctions_ } = await ajax({
                url: '/esb/portfolio/treasuryauctions',
                method: 'GET'
            })

            const auctions = await auctions_
            setAuctions(auctions.map(a => ({...a, ctfYield: a.ctfYield===0 ? null : a.ctfYield })))

            const { data:upcoming_ } = await ajax({
                url: '/esb/portfolio/treasuryauctions/upcoming',
                method: 'GET'
            })

            setUpcoming(await upcoming_)


            const { data:schedules_ } = await ajax({
                url: '/esb/portfolio/treasuryauctions/schedules',
                method: 'GET',
                type: 'text'
            })

            setSchedules(evalJson(await schedules_, []))
            setStatus(Status.LOADED)

        } catch(e) {
            setAuctions([])
            setUpcoming([])
            setSchedules([])
            setStatus(Status.FAILED_TO_LOAD)
        }
    })()}, [])

    return <Context.Provider value={{
        status,
        auctions,
        upcoming,
        schedules,
    }}>
    {children}
    </Context.Provider>
}

export const useTreasuryAuctions = () => React.useContext(Context)